import { useEffect, useState, useCallback } from "react";
import { Gauge, Wrench, Loader2, AlertTriangle, ClipboardCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

export default function WorkshopPreventive() {
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState("");

  const load = useCallback(() => { setLoading(true); api.get("/workshop/preventive/due").then((r) => setD(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);
  useEffect(() => { load(); }, [load]);

  const generate = async (v) => {
    setBusy(v.id);
    try {
      const { data } = await api.post(`/workshop/preventive/${v.id}/generate`);
      toast.success(`OT ${data.work_order.folio} generada para ${v.economico || v.placas}`);
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Error"); } finally { setBusy(""); }
  };

  const r = d?.resumen || {};
  return (
    <div data-testid="workshop-preventive">
      <div className="grid grid-cols-2 gap-3 mb-5 max-w-xs">
        <div className="card-surface p-3"><div className="text-[11px] text-navy/40">Unidades con plan</div><div className="text-lg font-medium">{r.total || 0}</div></div>
        <div className="card-surface p-3"><div className="text-[11px] text-navy/40">Por vencer / vencidos</div><div className={`text-lg font-medium ${r.vencidos > 0 ? "text-amber-600" : ""}`}>{r.vencidos || 0}</div></div>
      </div>

      {loading ? <div className="py-12 flex justify-center text-navy/40"><Loader2 className="w-6 h-6 animate-spin" /></div>
        : !d?.rows?.length ? (
          <div className="card-surface p-8 text-center text-sm text-navy/40">Configura <b>Mant. cada (km)</b> o <b>(días)</b> en el expediente de vehículos para activar el control preventivo.</div>
        ) : (
          <div className="space-y-2">
            {d.rows.map((v) => {
              const prog = Math.min(v.progreso, 100);
              return (
                <div key={v.id} className="card-surface p-4" data-testid={`preventive-row-${v.economico || v.id}`}>
                  <div className="flex items-center gap-3">
                    <Gauge className={`w-5 h-5 shrink-0 ${v.vencido ? "text-amber-600" : "text-navy/40"}`} />
                    <div className="min-w-0 flex-1">
                      <div className="text-sm font-medium truncate">{v.economico || "Unidad"} · {v.marca} {v.modelo} {v.placas ? `· ${v.placas}` : ""}</div>
                      <div className="text-[11px] text-navy/45">
                        {v.km_actual?.toLocaleString("es-MX")} km {v.intervalo_km ? `· ${v.km_desde_ultimo?.toLocaleString("es-MX")}/${v.intervalo_km?.toLocaleString("es-MX")} km desde últ.` : ""}
                        {v.intervalo_dias ? ` · ${v.dias_desde_ultimo ?? "?"}/${v.intervalo_dias} días` : ""}
                      </div>
                      <div className="h-1.5 bg-navy/10 rounded-full mt-2 overflow-hidden">
                        <div className={`h-full transition-all ${v.vencido ? "bg-amber-500" : "bg-gradient-violet"}`} style={{ width: `${prog}%` }} />
                      </div>
                    </div>
                    {v.vencido ? (
                      <button onClick={() => generate(v)} disabled={busy === v.id} className="btn btn-primary text-sm shrink-0" data-testid={`preventive-generate-${v.economico || v.id}`}>
                        {busy === v.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <ClipboardCheck className="w-4 h-4" />} Generar OT
                      </button>
                    ) : (
                      <span className="text-[11px] text-navy/40 shrink-0 flex items-center gap-1"><Wrench className="w-3.5 h-3.5" /> {v.progreso}%</span>
                    )}
                  </div>
                  {v.vencido && <div className="text-[11px] text-amber-600 mt-2 flex items-center gap-1"><AlertTriangle className="w-3 h-3" /> Servicio vencido por {v.motivo === "km" ? "kilometraje" : "tiempo"}</div>}
                </div>
              );
            })}
          </div>
        )}
    </div>
  );
}
